import React, { useContext, useEffect, useState, useRef } from "react";
// import "../../../App.css"
import {
  BuyCentral,
  Languages,
  UserType,
} from "../../../components/UI/Dropdown";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
} from "@radix-ui/react-dropdown-menu";
import {
  CurrencyDropdownLabelSVG,
  GetTheAppSVG,
  HamburgerBuyerCentral,
  HamburgerCart,
  HamburgerMemberShip,
  HamburgerMenu,
  HamburgerMessages,
  HamburgerRfq,
  HamburgerSell,
  HamburgerShip,
  HamburgerTradeShow,
  QuotationPageLogoSVG,
  ScrollToTopSVG,
  SmallNavbarSearch,
} from "../../../assets/svg/allSvg";
import { CurrencyContext } from "../../../provider/CurrencyProvider";
import Select, { components } from "react-select";
import Flag from "react-world-flags";
import {
  CameraSVG,
  CategoriesSVG,
  DollarPouchSVG,
  MessageSVG,
  SearchSVG,
  UserSVG,
  WishListSVG,
} from "../../../assets/svg/allSvg";
import { Formik } from "formik";
import { CircularProgress } from "@mui/material";
import OrderLogos from "../../../assets/homepage/navbar/OrderLogo.png";
import { useNavigate } from "react-router-dom";
import { Categories } from "../../UI/Categories";
import { UserAuthContext } from "../../../App";
import { commonPoint } from "../../../common/Apicall";
import { changeAccountTypeApi } from "../../../Apis/PaymentApi";
import { userProfileDetailsApi } from "../../../Apis/UserApi";
import { productSearchByStringApi } from "../../../Apis/ProductApi";
import { searchStoreByStringApi } from "../../../Apis/StoreApi";

const options = [
  { value: "India", label: "India" },
  { value: "USA", label: "USA" },
  { value: "China", label: "China" },
  { value: "Japan", label: "Japan" },
];

const shipToOptions = [
  { value: "INR", label: "India", country: "IN" },
  { value: "EUR", label: "Germany", country: "EU" },
  { value: "USD", label: "USA", country: "US" },
  { value: "GBP", label: "UK", country: "GB" },
  { value: "AED", label: "UAE", country: "AE" },
  { value: "AUD", label: "Australia", country: "AU" },
  { value: "CAD", label: "Canada", country: "CA" },
  { value: "CNY", label: "China", country: "CN" },
  { value: "JPY", label: "Japan", country: "JP" },
  { value: "KRW", label: "South Korea", country: "KR" },
  { value: "SAR", label: "Saudi Arabia", country: "SA" },
  { value: "RUB", label: "Russia", country: "RU" },
  { value: "AFN", label: "Afghanistan", country: "AF" },
  { value: "ALL", label: "Albania", country: "AL" },
  { value: "AMD", label: "Armenia", country: "AM" },
  // Add more currencies as needed
];

const currencyOptions = [
  { value: "INR", label: "INR (₹) - India", country: "IN" },
  { value: "EUR", label: "EUR (€) - Germany", country: "EU" },
  { value: "USD", label: "USD ($) - USA", country: "US" },
  { value: "GBP", label: "GBP (£) - UK", country: "GB" },
  { value: "AED", label: "AED (د.إ) - UAE", country: "AE" },
  { value: "AUD", label: "AUD (A$) - Australia", country: "AU" },
  { value: "CAD", label: "CAD ($) - Canada", country: "CA" },
  { value: "CNY", label: "CNY (¥) - China", country: "CN" },
  { value: "JPY", label: "JPY (¥) - Japan", country: "JP" },
  { value: "KRW", label: "KRW (₩) - S. Korea", country: "KR" },
  { value: "SAR", label: "SAR (ر.س) - Arabia", country: "SA" },
  { value: "RUB", label: "RUB (₽) - Russia", country: "RU" },
  { value: "AFN", label: "AFN (؋) - Afghanistan", country: "AF" },
  { value: "ALL", label: "ALL (Lek) - Albania", country: "AL" },
  { value: "AMD", label: "AMD (Դ) - Armenia", country: "AM" },
  // Add more currencies as needed
];

// Custom option component to include flag and label in Currency Converter:
const CustomOption = (props) => {
  return (
    <components.Option {...props}>
      <div className="flex items-center">
        <Flag
          code={props.data.country}
          className="w-[15px] h-[10px] mr-[9px]"
        />
        <div className="font-medium text-[12px] text-black">
          {props.data.label}
        </div>
      </div>
    </components.Option>
  );
};

// Custom single value component to include flag and label in Currency Converter:
const CustomSingleValue = (props) => {
  return (
    <components.SingleValue {...props}>
      <div className="flex items-center">
        <Flag
          code={props.data.country}
          className="w-[15px] h-[10px] mr-[9px]"
        />
        <div className="font-medium text-[12px] text-black">
          {props.data.label}
        </div>
      </div>
    </components.SingleValue>
  );
};

// Custom option component to include flag and label in Ship To:
const ShipToCustomOption = (props) => {
  return (
    <components.Option {...props}>
      <div className="flex items-center">
        <Flag
          code={props.data.country}
          className="w-[15px] h-[10px] mr-[9px]"
        />
        <div className="font-medium text-[12px] text-black">
          {props.data.label}
        </div>
      </div>
    </components.Option>
  );
};

// Custom single value component to include flag and label in Ship To:
const ShipToCustomSingleValue = (props) => {
  return (
    <components.SingleValue {...props}>
      <div className="flex items-center">
        <Flag
          code={props.data.country}
          className="w-[15px] h-[10px] mr-[9px]"
        />
        <div className="font-medium text-[12px] text-black">
          {props.data.label}
        </div>
      </div>
    </components.SingleValue>
  );
};

const Navbars = () => {
  const navigate = useNavigate();
  const [productTitle, setProductTitle] = useState("");
  const [supplerName, setSupplerName] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [emailStatus, setEmailStatus] = useState("");
  const { userUid, isLoggedIn } = useContext(UserAuthContext);
  const [verifySeller, setVerifySeller] = useState(false);
  const [selectType, setSelectType] = useState(0);
  const [sellerPopUp, setSellerPopUp] = useState(false);
  const [loader, setLoader] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [userData, setUserData] = useState({
    uid: "",
    name: "",
    email: "",
    phone: "",
    billingAddress: "",
    accountType: "",
    gstNumber: "",
    storeName: "",
    country: "",
  });

  const [buyerOverview, setBuyerOverview] = useState({
    inquiryCount: 0,
    wishlistCount: 0,
    orderCount: 0,
    AcceptedCount: 0,
    InProgressCount: 0,
    PendingCount: 0,
    RejectedCount: 0,
  });

  // useState for Hamburger Menu for smaller device:
  const [hamOpen, setHamOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleHamMenu = () => {
    setHamOpen(!hamOpen);
  };

  // Close the menu if clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setHamOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuRef]);

  //state and handler for Ship To:
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [locationOpen, setLocationOpen] = useState(false);

  const shipToDropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (
      shipToDropdownRef.current &&
      !shipToDropdownRef.current.contains(event.target)
    ) {
      setLocationOpen(false);
    }
  };

  useEffect(() => {
    if (locationOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [locationOpen]);

  const handleLocationChange = (selectedOption) => {
    setSelectedLocation(selectedOption);
    setLocationOpen(false);
    handleLocationSelect(selectedOption);
  };

  const handleLocationSelect = (item) => {
    setSelectedLocation(item);
    setLocationOpen(false);
  };
  //end of Ship To functionality Code.

  //handler for Currency Converter:
  const [isOpen, setIsOpen] = useState(false);
  const { currency, setCurrency } = useContext(CurrencyContext);
  const [selectedOption, setSelectedOption] = useState(
    currencyOptions.find((option) => option.value === currency)
  );
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSelectChange = (option) => {
    setSelectedOption(option);
  };

  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const handleChangeCurrency = () => {
    setCurrency(selectedOption.value);
    setIsOpen(false); // Close the dropdown
  };
  //end of Currency Converter Code.

  //code for Language Converter:
  const [selectedLanguage, setSelectedLanguage] = useState("en");

  const handleChange = (event) => {
    setSelectedLanguage(event.target.value);
  };
  //end of Language COnverter code.

  const toggleVerifyName = () => {
    setVerifySeller((prev) => !prev);
  };

  const toggleRegisterForm = () => {
    setSellerPopUp((prev) => !prev);
  };

  // signup function
  async function firebaseSignup(values) {
    try {
      const storeResponse = await fetch(
        `${commonPoint}/api/v1/store/registerSeller`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            storeID: userData?.uid,
            storeDesc: "",
            storeLogo: "",
            phoneNumber: userData?.phone || values.phoneNumber,
            storeName: values.storeName,
            storeAddress: values.address,
            city: values.city,
            country: values.country,
            state: values.state,
            gstNumber: userData?.gstNumber || values.gstNumber,
            postcode: "400050",
            isVerified: 0,
          }),
        }
      );

      if (!storeResponse.ok) {
        console.error("Store registration failed");
      }

      const response = await storeResponse.json();
      if (response?.message === "Store created successfully") {
        await changeAccountTypeApi();
      }

      toggleRegisterForm();
    } catch (error) {
      console.error("Error:", error);
    }
  }
  // fetch user / buyer details
  const fetchUserDetails = async () => {
    try {
      const response = await userProfileDetailsApi(userUid?.currentUser?.uid);
      setUserData({
        uid: userUid?.currentUser?.uid,
        name: userUid?.currentUser?.displayName,
        email: userUid?.currentUser?.email,
        billingAddress: response?.userData?.billingAddress,
        phone: response?.userData?.phoneNumber,
        accountType: response?.userData?.accountType,
        gstNumber: response?.userData?.gstNumber,
        storeName: response?.userData?.storeName,
      });
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  useEffect(() => {
    if (userUid?.currentUser?.uid) fetchUserDetails();
  }, [userUid?.currentUser?.uid]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;

      if (scrollTop > 160) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleOrdersClick = () => {
    if (isLoggedIn) {
      navigate("/orders");
    } else {
      navigate("/login");
    }
  };

  const handleUserIdClick = () => {
    if (isLoggedIn) {
      navigate("/orders/overview");
    } else {
      navigate("/login");
    }
  };

  const handleWishListClick = () => {
    if (isLoggedIn) {
      navigate("/orders/whishlist");
    } else {
      navigate("/login");
    }
  };

  // Function to handle input change click
  const handleInputChange = async (e) => {
    const inputValue = e.target.value;
    setProductTitle(inputValue);

    if (inputValue.trim() === "") {
      setSuggestions([]);
      setShowSuggestions(false);
      return;
    }

    try {
      const response = await productSearchByStringApi(inputValue);
      if (response?.products?.length > 0) {
        setSuggestions(response.products.slice(0, 10));
        setShowSuggestions(true);
      } else {
        setSuggestions([]);
        setShowSuggestions(false);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const handleSearchSupplier = async (e) => {
    const inputValue = e.target.value;
    setSupplerName(inputValue);

    if (inputValue.trim() === "") {
      setSuggestions([]);
      setShowSuggestions(false);
      return;
    }

    try {
      const response = await searchStoreByStringApi(inputValue);
      if (response?.allStore?.length > 0) {
        setSuggestions(response.allStore.slice(0, 10));
        setShowSuggestions(true);
      } else {
        setSuggestions([]);
        setShowSuggestions(false);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  // Function to handle suggestion selection
  const handleSuggestionClick = (product) => {
    navigate(`/productId/${product.productID}`); // Navigate to product details page
    setShowSuggestions(false);
  };

  // Function to handle form submission on Enter key press
  const handleFormSubmit = (e) => {
    e.preventDefault();
    navigate("/AllProductsPage");
  };

  const handleQuotationForm = () => {
    navigate("/QuotationFormPage");
  };

  // delete token on logout
  //  function deleteCookie(name) {
  //   document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  //  }

  const handleSignInToAddressClick = () => {
    if (isLoggedIn) {
      navigate("/orders/overview"); // Redirect to the user's profile or order overview page
    } else {
      navigate("/login"); // Redirect to the login page
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      boxShadow: state.isFocused ? null : null,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#FF6300"
        : state.isFocused
        ? "lightgrey"
        : "white",
      color: state.isSelected ? "white" : "black",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "white" : null,
    }),
  };

  return (
    <>
      <div className="hidden md:block">
        <div className="text-[13px] bg-white md:bg-[#F8F8F8] lg:bg-white w-screen md:h-[68px] lg:h-[120px] ">
          {/* Scroll to Top Button */}
          <button
            className={`${
              isVisible ? "visible" : "invisible"
            } fixed animate-bounce bottom-12 flex items-center justify-center right-12 bg-[#FF6300] text-white rounded-full w-[40px] h-[40px] text-[40px] font-semibold`}
            onClick={scrollToTop}
            title="Scroll to Top"
          >
            {ScrollToTopSVG}
          </button>

          {/* Main Content Container */}
          <div className="max-w-[1241px] m-auto">
            {/* Flex Container for Desktop and Larger Devices */}
            <div className="hidden lg:flex justify-between pt-[10px]">
              {/* Left Side: Ship To, Language Converter, Currency Converter */}
              <div className="flex w-auto h-[30px] items-center justify-start">
                {/* Ship To Dropdown: */}
                <div className="flex items-center gap-x-[5px] mr-[10px]">
                  <button className="w-[44px] h-[18px] text-[12px] select-none">
                    Ship to:
                  </button>
                  <div className="relative" ref={shipToDropdownRef}>
                    <div
                      className="flex gap-x-2 cursor-pointer items-center justify-between"
                      onClick={() => setLocationOpen(!locationOpen)}
                    >
                      {selectedLocation ? (
                        <>
                          <Flag
                            code={selectedLocation.country}
                            alt="ShipToFlag"
                            className="h-[10px] w-[15px]"
                          />
                        </>
                      ) : (
                        <span className="font-regular text-[13px] text-black">
                          Select Location
                        </span>
                      )}
                      <svg width="10" height="9" viewBox="0 0 10 3" fill="none">
                        <path
                          d="M1 1L4.5 4L8 1"
                          stroke="black"
                          strokeOpacity="0.6"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>

                    {locationOpen && (
                      <div className="absolute -left-[130px] mt-2 w-[307px] bg-white rounded-[10px] shadow-[0_0px_0px_1px_rgba(0,0,0,0.07)] z-10">
                        <div className="flex flex-col items-center justify-center p-4">
                          <p className="text-[#FF6300] text-[14px] font-semibold">
                            Your location
                          </p>
                          <p className="my-[15px] text-[12px] font-medium text-center">
                            Shipping charges may vary depending on your
                            location.
                          </p>

                          {!isLoggedIn && (
                            <>
                              <button
                                className="w-[192px] h-[36px] bg-[#FF6300] text-white text-[12px] rounded-[5px] font-semibold"
                                onClick={handleSignInToAddressClick}
                              >
                                Sign In to add Address
                              </button>
                              <div className="flex items-center pb-[14px] pt-[17px] w-full justify-between">
                                <div className="w-20 border-t-2 border-gray-300" />
                                <p className="text-[12px] font-medium text-black w-16 text-center">
                                  Or
                                </p>
                                <div className="w-20 border-t-2 border-gray-300" />
                              </div>
                            </>
                          )}

                          <div className="w-full mb-5 flex flex-col">
                            <h2 className="text-left text-black text-[12px] font-medium mb-2">
                              Enter Country Name
                            </h2>
                            <Select
                              options={shipToOptions}
                              value={selectedLocation}
                              onChange={handleLocationChange}
                              className="w-full font-medium text-[12px]"
                              components={{
                                Option: ShipToCustomOption,
                                SingleValue: ShipToCustomSingleValue,
                              }}
                              isSearchable={false}
                            />
                          </div>

                          <div className="w-full mb-5 flex flex-col">
                            <h2 className="text-left text-black text-[12px] font-medium mb-2">
                              Enter Pincode
                            </h2>
                            <input
                              type="text"
                              className="w-full h-[37px] px-2 text-[12px] font-medium border rounded-[5px]"
                              placeholder="400050"
                            />
                          </div>

                          <button className="w-[130px] h-[36px] bg-[#FF6300] text-white text-[12px] rounded-[5px] font-semibold">
                            Save
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <hr className="opacity-45 w-[1px] h-[15px] bg-black" />

                {/* Language Converter Dropdown: */}
                <div className="flex items-center mx-[15px] justify-center w-auto h-[20px]">
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <div className="flex items-center gap-x-2 cursor-pointer">
                        <p className="w-[71px] h-[18px] font-regular text-[12px]">
                          Language -
                        </p>
                        <img
                          src={require("../../../assets/homepage/navbar/USAFlag.png")}
                          className="h-[12px]"
                          alt="LanguageImg"
                        />
                        <p>English US</p>
                        <svg
                          width="10"
                          height="9"
                          viewBox="0 0 10 3"
                          fill="none"
                          className="cursor-pointer"
                        >
                          <path
                            d="M1 1L4.5 4L8 1"
                            stroke="black"
                            strokeOpacity="0.6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent
                      className={`z-10 w-[307px] h-[241px] mt-4 px-8 bg-white rounded-[10px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]`}
                    >
                      <p className="pt-[22px] text-[#FF6300] text-sm font-semibold text-[14px] text-center">
                        Change Language
                      </p>
                      <p className="text-left mb-[15px] mt-[15px] text-xs font-medium">
                        Select Language
                      </p>
                      <div className="flex flex-col justify-center">
                        <label htmlFor="language" className="mr-2">
                          Select Language:
                        </label>
                        <select
                          id="language"
                          value={selectedLanguage}
                          onChange={handleChange}
                          className="bg-white border border-gray-300 rounded-lg px-4 py-2 shadow-sm focus:outline-none focus:border-blue-500"
                        >
                          <option value="en">English</option>
                          <option value="es">Spanish</option>
                          <option value="fr">French</option>
                          <option value="de">German</option>
                          <option value="zh">Chinese</option>
                        </select>
                      </div>
                      <div className="mt-[30px] flex justify-center">
                        <button className="w-28 h-10 bg-[#FF6300] text-[12px] rounded-md text-white font-semibold">
                          Change
                        </button>
                      </div>
                    </DropdownMenuContent>
                  </DropdownMenu>
                </div>

                <hr className="opacity-45 w-[1px] h-[15px] bg-black" />

                {/* Currency Converter Dropdown: */}
                <div className="flex items-center mx-[15px] justify-center w-auto h-[20px]">
                  <p className="w-[65px] h-[18px] text-[12px] select-none">
                    Currency :
                  </p>
                  <div className="relative" ref={dropdownRef}>
                    <div
                      className="flex gap-x-2 items-center cursor-pointer"
                      onClick={toggleDropdown}
                    >
                      <Flag
                        code={selectedOption.country}
                        className="h-[10px] w-[15px]"
                        alt="CountryFlag"
                      />
                      <p className="select-none">{selectedOption.label}</p>
                      {CurrencyDropdownLabelSVG}
                    </div>
                    {isOpen && (
                      <div className="absolute -left-[130px] z-10 w-[307px] h-[241px] mt-2 px-8 bg-white rounded-[10px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
                        <p className="pt-[22px] text-[#FF6300] text-sm font-semibold text-[14px] text-center">
                          Change Currency
                        </p>
                        <p className="text-left mb-[8px] mt-[24px] text-[12px] font-medium">
                          Select Currency
                        </p>

                        <Select
                          value={selectedOption}
                          onChange={handleSelectChange}
                          options={currencyOptions}
                          className="react-select-container"
                          classNamePrefix="react-select"
                          components={{
                            Option: CustomOption,
                            SingleValue: CustomSingleValue,
                          }}
                          isSearchable={false}
                          styles={customStyles}
                        />
                        <div className="mt-[40px] flex justify-center">
                          <button
                            className="w-28 h-10 bg-[#FF6300] text-[12px] rounded-md text-white font-semibold"
                            onClick={handleChangeCurrency}
                          >
                            Change
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <hr className="opacity-45 w-[1px] h-[15px] bg-black" />

                <div className="flex items-center ml-[19px] justify-center">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.naayatrade.naayatrade&pli=1"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className=" w-[120px] h-[30px] flex items-center justify-start gap-x-[5px]">
                      {GetTheAppSVG}
                      <p className="w-[90px] h-[18px] flex items-center justify-start">
                        Get the App
                      </p>
                    </button>
                  </a>
                </div>
              </div>
              <div className="flex gap-x-[30px] w-auto justify-end items-center">
                <button>
                  <div className="flex gap-x-1 items-center">
                    {DollarPouchSVG}
                    <button
                      className="text-[12px]"
                      onClick={toggleRegisterForm}
                    >
                      Sell On Naayatrade
                    </button>
                    {sellerPopUp && (
                      <div className="fixed inset-0 flex items-center justify-center bg-black h-[710px] bg-opacity-50 z-50">
                        <div className="w-[606px] h-[690px] bg-white rounded-[10px] items-center justify-between text-center">
                          <div className="w-full">
                            <div className="flex items-center justify-between">
                              <div className="w-[174px] h-[27px] flex-shrink-0 mt-[13px] ml-[29px] text-[18px] font-semibold text-[#FF8100] leading-[27px] text-start select-none">
                                Seller Registration
                              </div>
                            </div>
                          </div>
                          <Formik
                            initialValues={{
                              name: "",
                              phoneNumber: "",
                              email: "",
                              storeName: "",
                              gstNumber: "",
                              isAgree: false,
                              country: "",
                              state: "",
                              city: "",
                              address: "",
                            }}
                            validate={(values) => {
                              const errors = {};
                              // name
                              if (!userData?.name && !values.name) {
                                errors.name = "Required";
                              }

                              // phoneNumber
                              if (
                                !userData?.phone &&
                                (!values.phoneNumber ||
                                  !/^\+?\d{10,15}$/i.test(values.phoneNumber))
                              ) {
                                errors.phoneNumber = !values.phoneNumber
                                  ? "Required"
                                  : "Invalid Phone Number";
                              }

                              // email
                              if (!userData?.email) {
                                if (!values.email) {
                                  errors.email = "Required";
                                } else if (
                                  !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                                    values.email
                                  )
                                ) {
                                  errors.email = "Invalid email address";
                                }
                              }

                              // gstNumber
                              if (!userData?.gstNumber) {
                                if (!values.gstNumber) {
                                  errors.gstNumber = "Required";
                                } else if (
                                  !/^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/i.test(
                                    values.gstNumber
                                  )
                                ) {
                                  errors.gstNumber = "Invalid GST Number";
                                }
                              }

                              if (!values.isAgree)
                                errors.isAgree =
                                  "You must agree to the terms and conditions";

                              return errors;
                            }}
                            onSubmit={async (values) => {
                              try {
                                firebaseSignup(values);
                              } catch (err) {
                                console.log("Firebase error");
                              }
                            }}
                          >
                            {({
                              values,
                              errors,
                              touched,
                              handleChange,
                              handleBlur,
                              handleSubmit,
                              isSubmitting,
                            }) => (
                              <div>
                                <div className="flex gap-x-[45px] w-full pl-[29px] mt-[10px]">
                                  <div className="flex flex-col float-start ml-0 text-left w-[240px]">
                                    <p className="text-[14px] font-medium w-[45px] h-[21px] text-black">
                                      Name
                                    </p>
                                    <input
                                      name="name"
                                      disabled={userData?.name}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={userData?.name || values.name}
                                      className="w-[240px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                      placeholder="Enter your name"
                                    />
                                    {errors.name && (
                                      <p className="text-red-600 text-[12px]">
                                        {errors.name}
                                      </p>
                                    )}
                                  </div>

                                  <div className="flex flex-col float-start ml-0 text-left w-[240px]">
                                    <p className="text-[14px] font-medium w-[109px] h-[21px] text-black">
                                      Phone Number
                                    </p>
                                    <input
                                      maxLength={10}
                                      name="phoneNumber"
                                      disabled={userData?.phone}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={
                                        userData?.phone || values.phoneNumber
                                      }
                                      className="w-[240px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                      placeholder="Enter your phone number"
                                    />
                                    {errors.phoneNumber && (
                                      <p className="text-red-600 text-[12px]">
                                        {errors.phoneNumber}
                                      </p>
                                    )}
                                  </div>
                                </div>

                                <div className="flex flex-col float-start pl-[29px] text-left w-full mt-[10px]">
                                  <p className="text-[14px] font-medium w-[109px] text-black">
                                    Email
                                  </p>
                                  <input
                                    name="email"
                                    disabled={userData?.email}
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={userData.email || values.email}
                                    className="w-[526px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                    placeholder="Enter your Email ID"
                                  />
                                  {errors.email && (
                                    <p className="text-red-600 text-[12px]">
                                      {errors.email}
                                    </p>
                                  )}
                                </div>

                                <div className="flex gap-x-[45px] w-full pl-[29px] mt-[10px]">
                                  <div className="flex flex-col float-start ml-0 text-left w-[240px]">
                                    <div className="flex items-center">
                                      <p className="text-[14px] font-medium w-[88px] h-[21px] text-black">
                                        Store Name
                                      </p>
                                    </div>
                                    <input
                                      name="storeName"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.storeName}
                                      className="w-[240px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                      placeholder="Enter your Store name"
                                    />
                                    {errors.storeName && (
                                      <p className="text-red-600 text-[12px]">
                                        {errors.storeName}
                                      </p>
                                    )}
                                  </div>

                                  <div className="flex flex-col float-start ml-0 text-left w-[240px]">
                                    <div className="flex items-center">
                                      <p className="text-[14px] font-medium w-[93px] h-[21px] text-black">
                                        GST Number
                                      </p>
                                    </div>
                                    <input
                                      name="gstNumber"
                                      disabled={userData?.gstNumber}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={
                                        userData?.gstNumber || values.gstNumber
                                      }
                                      className="w-[240px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                      placeholder="Enter your 15 Digit GST number"
                                    />
                                    {errors.gstNumber && (
                                      <p className="text-red-600 text-[12px]">
                                        {errors.gstNumber}
                                      </p>
                                    )}
                                  </div>
                                </div>

                                <div className="flex mt-[5px] w-full pl-[29px] gap-x-[17px]">
                                  <div className="flex flex-col ml-0 text-left w-[164px]">
                                    <p className="text-[14px] font-medium w-[59px] text-black">
                                      Country
                                    </p>
                                    <select
                                      className="w-[163px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                      name="country" // Make sure the name matches the field name in initialValues
                                      value={values.country} // Set the value from Formik's state
                                      onChange={handleChange} // Call handleChange to update Formik's state
                                    >
                                      <option
                                        className="text-[#B3B3B3]"
                                        value=""
                                      >
                                        Select Country
                                      </option>
                                      {options.map((option) => (
                                        <option
                                          key={option.value}
                                          value={option.value}
                                        >
                                          {option.label}
                                        </option>
                                      ))}
                                    </select>
                                  </div>

                                  <div className="col-start-4 col-end-7">
                                    <div className="flex flex-col float-start ml-0 text-left w-[164px]">
                                      <p className="text-[14px] font-medium w-[59px] text-black">
                                        State
                                      </p>
                                      <select
                                        className="w-[163px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                        name="state"
                                        value={values.state}
                                        onChange={handleChange}
                                      >
                                        <option
                                          className="text-[#B3B3B3]"
                                          value=""
                                        >
                                          Select State
                                        </option>
                                        {options.map((option) => (
                                          <option
                                            key={option.value}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-start-7 col-end-13">
                                    <div className="flex flex-col float-start ml-0 text-left w-[164px]">
                                      <p className="text-[14px] font-medium w-[59px] text-black">
                                        City
                                      </p>
                                      <select
                                        className="w-[163px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                        name="city"
                                        value={values.city}
                                        onChange={handleChange}
                                      >
                                        <option
                                          className="text-[#B3B3B3]"
                                          value=""
                                        >
                                          Select City
                                        </option>
                                        {options.map((option) => (
                                          <option
                                            key={option.value}
                                            value={option.value}
                                          >
                                            {option.label}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div className="flex flex-col float-start pl-[29px] text-left w-full mt-[5px]">
                                  <p className="text-[14px] font-medium w-[109px] h-[21px] text-black">
                                    Address
                                  </p>
                                  <textarea
                                    name="address"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.address}
                                    rows="2"
                                    maxlength="150"
                                    className="w-[526px] h-[55px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3] resize-none"
                                    placeholder="Enter Company Address"
                                  />
                                </div>

                                <div className="flex pt-[10px] w-[548px] gap-x-[12px] ml-[29px] ">
                                  <label>
                                    <input
                                      name="isAgree"
                                      className="h-[20px] w-[20px]"
                                      type="checkbox"
                                      value={values.isAgree}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                  </label>
                                  <p className="text-[12px] pr-[10px] font-medium text-left w-[500px]">
                                    I Agree To Terms & Conditions I agree to
                                    <span className="text-[#FF6300]">
                                      {" "}
                                      (a) Terms Of Use{" "}
                                    </span>
                                    and
                                    <span className="text-[#FF6300]">
                                      {" "}
                                      (b) Privacy Policy.
                                    </span>{" "}
                                    I agree to receive more information from
                                    Naayatrade.com about its products and
                                    services.
                                  </p>
                                </div>
                                {errors.isAgree && (
                                  <p className="text-red-600 text-[12px]">
                                    {errors.isAgree}
                                  </p>
                                )}
                                {emailStatus && (
                                  <p className="text-red-600 text-[12px]">
                                    {emailStatus}
                                  </p>
                                )}

                                <div className="w-full flex items-center justify-center">
                                  {!loader ? (
                                    <button
                                      type="submit"
                                      onClick={() => {
                                        handleSubmit();
                                        toggleVerifyName();
                                      }}
                                      className="text-white bg-[#FF6300] w-[130px] h-[48px] rounded-[10px] mt-[15px] flex items-center justify-center"
                                    >
                                      REGISTER
                                    </button>
                                  ) : (
                                    <button className="register-button text-white bg-[#FF6300] w-[130px] h-[48px] rounded-[10px] mt-[15px] flex items-center justify-center">
                                      <CircularProgress
                                        color="inherit"
                                        size={24}
                                      />
                                    </button>
                                  )}
                                </div>
                              </div>
                            )}
                          </Formik>
                        </div>
                      </div>
                    )}
                  </div>
                </button>
                <button>
                  <div className="flex gap-x-1 items-center">
                    {MessageSVG}
                    <button className="text-[12px]">Messages</button>
                  </div>
                </button>
                <button>
                  <button
                    className="flex gap-x-1 items-center"
                    onClick={handleWishListClick}
                  >
                    {WishListSVG}
                    <p className="text-[12px]">Wishlist</p>
                  </button>
                </button>
                <button
                  onClick={handleUserIdClick}
                  className="flex items-center justify-center"
                >
                  <div className="flex gap-x-1 items-center justify-center">
                    {UserSVG}
                    <button className="text-[12px]">
                      {!isLoggedIn
                        ? "Sign in"
                        : userUid?.currentUser?.displayName}
                    </button>
                  </div>
                </button>
              </div>
            </div>
            <div className="flex md:items-center md:justify-center md:h-[68px] lg:items-center lg:justify-between lg:mt-[10px] md:gap-x-[16px] lg:gap-x-0">
              <button>
                <img
                  src={require("../../../assets/homepage/navbar/naayaLogo.png")}
                  className="md:w-[150px] md:h-[36px] lg:w-[219px] lg:h-[53px] cursor-pointer"
                  alt="Logo"
                  onClick={() => navigate("/")}
                />
              </button>
              <form
                onSubmit={handleFormSubmit}
                className="flex justify-between items-center border-2 md:w-[554px] md:h-[36px] lg:w-[693px] lg:h-[38px] border-black px-1 py-1 rounded-full"
              >
                <div className="flex items-center gap-x-4 w-[500px]">
                  {UserType(selectType, setSelectType)}
                  <hr className="opacity-45 w-[1px] h-[20px] bg-black" />
                  {selectType === 0 ? (
                    <input
                      placeholder="What are you looking for ?"
                      className="focus:outline-nones md:w-[230px] lg:w-[370px] md:bg-transparent lg:bg-white"
                      value={productTitle}
                      onChange={handleInputChange}
                    />
                  ) : (
                    <input
                      placeholder="What are you looking for ?"
                      className="focus:outline-nones md:w-[230px] lg:w-[370px] md:bg-transparent lg:bg-white"
                      value={supplerName}
                      onChange={handleSearchSupplier}
                    />
                  )}
                </div>
                <div className="flex items-center gap-x-2">
                  {CameraSVG}
                  <button className="flex items-center text-white gap-x-[5px] bg-[#FF6300] cursor-pointer px-6 py-1 rounded-full">
                    {SearchSVG}
                    Search
                  </button>
                </div>
              </form>
              <div className="hidden lg:flex items-center gap-x-[25px] justify-between">
                <button
                  className="flex items-center gap-x-[10px] justify-center w-[126px] h-[40px]"
                  onClick={handleQuotationForm}
                >
                  {QuotationPageLogoSVG}
                  <p className="w-[83px] h-[40px] text-[14px] select-none">
                    Request for Quotations
                  </p>
                </button>
                <button
                  // onClick={() => navigate("/orders")}
                  onClick={handleOrdersClick}
                  className="flex items-center gap-x-[10px] justify-between w-[90px] h-[40px]"
                >
                  <img
                    src={OrderLogos}
                    alt="OrderLogo"
                    className="w-[30px] h-[30px]"
                  />
                  <button className="w-[47px] h-[18px] text-[14px] select-none">
                    Orders
                  </button>
                </button>
              </div>
            </div>
          </div>
        </div>

        <hr className="hidden lg:block w-screen bg-black" />

        <div className="hidden lg:block bg-white w-screen h-[38px] ">
          <div className="max-w-[1241px] m-auto h-[38px] flex items-center justify-start">
            <div className="flex items-center justify-start w-[864px]">
              <div className="flex items-center gap-x-[5px] select-none">
                {CategoriesSVG}
                <Categories />
              </div>
              <hr className="opacity-45 w-[1px] h-[15px] bg-black" />
              <button className="hover:text-[#FF6300] select-none cursor-pointer w-[90px] h-[18px] text-[13px] mx-[13px] flex items-center justify-center">
                Ready to ship
              </button>
              <hr className="opacity-45 w-[1px] h-[15px] bg-black" />
              <button className="hover:text-[#FF6300] select-none cursor-pointer w-[165px] h-[18px] text-[13px] mx-[13px] flex items-center justify-center">
                Naayatrade Membership
              </button>
              <hr className="opacity-45 w-[1px] h-[15px] bg-black" />
              <div className="select-none">{BuyCentral}</div>
              <hr className="opacity-45 w-[1px] h-[15px] bg-black" />
              <div className="select-none hover:text-[#FF6300] cursor-pointer w-[85px] h-[18px] text-[13px] mx-[13px] flex items-center justify-center">
                {/* {tradeShows} */}
                Trade Shows
              </div>
              <hr className="opacity-45 w-[1px] h-[15px] bg-black" />
              <button className="hover:text-[#FF6300] select-none cursor-pointer w-[125px] h-[18px] text-[13px] mx-[13px] flex items-center justify-center">
                Sell on Naayatrade
              </button>
              <hr className="opacity-45 w-[1px] h-[15px] bg-black" />
              <button className="hover:text-[#FF6300] select-none cursor-pointer w-[27px] h-[18px] text-[13px] mx-[13px] flex items-center justify-center">
                Help
              </button>
            </div>
          </div>
        </div>

        <hr className="hidden lg:block w-screen bg-black" />
        {showSuggestions && (
          <>
            {selectType === 0 ? (
              <div className="bg-white absolute top-[100px] left-0 right-[22px] w-[693px] m-auto border border-gray-300 shadow-[0_0px_0px_1px_rgba(0,0,0,0.01)] rounded-[5px] z-50 overflow-y-scroll">
                {suggestions.map((product) => (
                  <div
                    key={product.productId}
                    className="flex items-center px-4 py-2 cursor-pointer hover:bg-gray-100 gap-x-[10px]"
                    onClick={() => handleSuggestionClick(product)}
                  >
                    <img
                      src={product.images[0]}
                      alt={product.productTitle}
                      className="w-[40px] h-[40px] mr-2"
                    />
                    <p className="text-sm truncate">{product.productTitle}</p>
                    <p className="text-sm truncate font-semibold">
                      ₹{product.maxPrice}
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <div className="bg-white absolute top-[100px] left-0 right-[22px] w-[693px] m-auto border border-gray-300 shadow-[0_0px_0px_1px_rgba(0,0,0,0.01)] rounded-[5px] z-50 overflow-y-scroll">
                {suggestions.map((store) => (
                  <div
                    key={store.storeID}
                    className="flex items-center px-4 py-2 cursor-pointer hover:bg-gray-100 gap-x-[10px]"
                  >
                    {store?.bannerImages?.length > 0 && (
                      <img
                        src={store.bannerImages[0]}
                        alt={store.storeName}
                        className="w-[40px] h-[40px] mr-2"
                      />
                    )}
                    <p className="text-sm truncate">{store.storeName}</p>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>

      <header className="md:hidden w-full h-[210px]">
        <div className="bg-navbar-image bg-no-repeat bg-center bg-cover w-full h-[191px] flex flex-col items-center justify-between pt-[50px] pb-[43px] px-[16px]">
          <img
            src={require("../../../assets/homepage/navbar/naayaLogo.png")}
            alt=""
            className="w-[145px] h-[35px]"
          />

          <div className="w-full h-[40px] flex flex-row items-center justify-between">
            <div className="w-[217px] h-[40px] flex flex-row items-center gap-x-[10px]">
              <button
                className="w-[31px] h-[32px] flex items-center justify-center rounded-[5px] bg-white"
                onClick={toggleHamMenu}
              >
                {HamburgerMenu}
              </button>
              <div className="w-[176px] h-[40px]">
                <p className="w-[176px] h-[21px] font-semibold text-[14px] text-black">
                  Welcome to{" "}
                  <span className="text-[#FF6300] font-bold text-[14px]">
                    Naayatrade
                  </span>
                </p>
                <p className="text-[#858585] w-[162px] h-[18px] font-medium text-[12px]">
                  New era of doing business.
                </p>
              </div>
            </div>

            <button className="w-[73px] h-[30px] bg-[#FF6300] text-white flex items-center justify-center font-semibold text-[12px] rounded-[10px]">
              Sign In
            </button>
          </div>
        </div>

        <div className="relative -top-[25px] flex items-center justify-center">
          <input
            type="text"
            placeholder="Search Products & Suppliers"
            className="w-[328px] h-[42px] rounded-[10px] p-[12px] placeholder:text-[12px] placeholder:text-[#BABABA] placeholder:w-[169px] placeholder:h-[18px] text-[12px] text-black shadow-[0_0px_0px_1px_rgba(0,0,0,0.07)]"
          />
          <div className="absolute inset-y-0 right-0 flex items-center pr-[30px]">
            {SmallNavbarSearch}
          </div>
        </div>

        <div
          ref={menuRef}
          className={`fixed top-0 left-0 h-full w-[247px] z-50 bg-white text-black transform ${
            hamOpen ? "translate-x-0" : "-translate-x-full"
          } transition-transform duration-300 ease-in-out md:hidden`}
        >
          <div className="py-[30px] px-[16px] flex flex-col gap-y-[16px]">
            <div className="flex flex-row font-medium text-[14px] text-black gap-x-[8px] h-[30px] items-center">
              {HamburgerMessages}
              Messages
            </div>
            <div className="flex flex-row font-medium text-[14px] text-black gap-x-[8px] h-[30px] items-center">
              {HamburgerCart}
              Cart
            </div>
            <div className="flex flex-row font-medium text-[14px] text-black gap-x-[8px] h-[30px] items-center">
              <img
                src={require("../../../assets/homepage/navbar/Quotations.jpg")}
                alt="OrderLogo"
                className="w-[20px] h-[20px]"
              />
              RFQ
            </div>
            <div className="flex flex-row font-medium text-[14px] text-black gap-x-[8px] h-[30px] items-center">
              <img
                src={require("../../../assets/homepage/navbar/OrderLogo.png")}
                alt="OrderLogo"
                className="w-[20px] h-[20px]"
              />
              Orders
            </div>
            <hr className="w-full text-black h-[2px]" />
            <div className="flex flex-row font-medium text-[14px] text-black gap-x-[8px] h-[30px] items-center">
              {HamburgerShip}
              Ready To Ship
            </div>
            <div className="flex flex-row font-medium text-[14px] text-black gap-x-[8px] h-[30px] items-center">
              {HamburgerMemberShip}
              Naayatrade Membership
            </div>
            <div className="flex flex-row font-medium text-[14px] text-black gap-x-[8px] h-[30px] items-center">
              {HamburgerBuyerCentral}
              Buyer Central
            </div>
            <div className="flex flex-row font-medium text-[14px] text-black gap-x-[8px] h-[30px] items-center">
              {HamburgerTradeShow}
              Trade Shows
            </div>
            <div className="flex flex-row font-medium text-[14px] text-black gap-x-[8px] h-[30px] items-center">
              {HamburgerSell}
              Sell on Naayatrade
            </div>
            <hr className="w-full text-black h-[2px]" />
            <div className="flex flex-row font-medium text-[14px] text-black gap-x-[8px] h-[30px] items-center">
              Ship to
            </div>
            <div className="flex flex-row font-medium text-[14px] text-black gap-x-[8px] h-[30px] items-center">
              Language
            </div>
            <div className="flex flex-row font-medium text-[14px] text-black gap-x-[8px] h-[30px] items-center">
              Currency
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Navbars;
